import React from 'react';
import { Link } from 'react-router-dom';
import { LEGAL } from './legalConfig';
import './Legal.scss';

const Terms: React.FC = () => (
  <article className="legal">
    <h1 className="legal__title">Пользовательское соглашение</h1>
    <p className="legal__meta">Редакция от {LEGAL.updatedAt}</p>

    <h2>1. Предмет соглашения</h2>
    <p>
      Сайт {LEGAL.siteName} (далее — «Сайт») — информационная система для проведения турниров по дзюдо:
      регистрация участников, подача заявок, жеребьёвка, турнирные сетки, протоколы и результаты. Сайт
      принадлежит {LEGAL.operatorName} ({LEGAL.operatorDetails}). Используя Сайт, пользователь принимает условия
      настоящего соглашения.
    </p>

    <h2>2. Регистрация</h2>
    <ul>
      <li>Пользователь обязуется указывать достоверные данные и действующий адрес электронной почты.</li>
      <li>Регистрация завершается после подтверждения адреса электронной почты по коду из письма.</li>
      <li>Пользователь отвечает за сохранность пароля и за действия, совершённые под его учётной записью.</li>
      <li>
        Лица младше 18 лет регистрируются с согласия родителей или законных представителей.
      </li>
    </ul>

    <h2>3. Участие в турнирах</h2>
    <ul>
      <li>
        Заявка на турнир подаётся на Сайте до окончания срока регистрации, указанного в карточке турнира.
        Категория определяется автоматически по возрасту, полу и весу на дату начала турнира.
      </li>
      <li>
        Допуск к соревнованиям, взвешивание и прочие условия определяются регламентом турнира и решениями организаторов.
        Сведения о весе, указанные в заявке, могут быть уточнены на взвешивании.
      </li>
      <li>Заявку можно отозвать на Сайте, пока открыта регистрация и не проведена жеребьёвка в категории участника.
        После этого обратитесь к организатору.</li>
      <li>Организатор вправе отклонить заявку или исключить участника при нарушении регламента.</li>
    </ul>

    <h2>4. Правила использования</h2>
    <p>Запрещается: указывать чужие данные, пытаться получить несанкционированный доступ к Сайту, нарушать его
      работу, использовать автоматизированные средства массовой регистрации.</p>

    <h2>5. Ответственность</h2>
    <p>
      Сайт предоставляется «как есть». Оператор принимает разумные меры для бесперебойной работы, но не гарантирует
      отсутствия перерывов. Состояние здоровья и допуск к занятиям спортом — ответственность самого участника
      (его законных представителей) и организаторов турнира.
    </p>

    <h2>6. Персональные данные</h2>
    <p>
      Порядок обработки персональных данных описан в <Link to="/privacy">Политике конфиденциальности</Link>.
    </p>

    <h2>7. Контакты</h2>
    <p>По вопросам работы Сайта: {LEGAL.contactEmail}.</p>

    <p className="legal__back">
      <Link to="/privacy">Политика конфиденциальности</Link>
      {' · '}
      <Link to="/">На главную</Link>
    </p>
  </article>
);

export default Terms;
